import {Injectable}     from 'angular2/core';
import {Http, Response} from 'angular2/http';
import {Observable}     from 'rxjs/Observable';
import {Campaign}       from "../../models/campaign.model";
import {App}            from "../../app_config";
import {CustomBaseRequestOptions} from "../../http/custom_base_request_options";
import {AbstractService} from "../abstract.service";
import * as FileSaver from 'file-saver';

declare var saveAs: typeof FileSaver.saveAs;

@Injectable()
export class CampaignService extends AbstractService {

    constructor(private http:Http) {
        super();
    }

    private _campaignUrl = App.AppConfig.apiEndPoint + '/campaign';

    getCampaigns(page:number, perPage:number, sort:string, reverse:boolean, searchPattern:string, searchFilter:any):Observable<Campaign[]> {
        page = page - 1;
        if (searchPattern.length === 0) { searchPattern = "*"; }
        return this.http.get(this._campaignUrl + "/list/" + perPage + "/" + page + "/" + sort + "/"
        + (reverse ? "-1" : "1") + "/"
        + searchPattern + "/" + this.filtersToString(searchFilter))
            .map(this.extractData)
            .map(campaigns => campaigns.map(campaign => new Campaign(campaign)))
            .catch(this.handleError);
    }

    filtersToString(searchFilter:any) {
        let filter = 0;
        if (searchFilter.expected) { filter += 0x01; }
        if (searchFilter.inprogress) { filter += 0x02; }
        if (searchFilter.soldout) { filter += 0x04; }
        if (searchFilter.finished) { filter += 0x08; }
        return filter;
    }

    count(searchPattern:string, searchFilter:any):Observable<number> {
        if (searchPattern.length === 0) { searchPattern = "*"; }
        return this.http.get(this._campaignUrl + "/count/" + searchPattern + "/" + this.filtersToString(searchFilter))
            .map(response => response.json());
    }

    createCampaign(campaign:Campaign) {
        let options = new CustomBaseRequestOptions();
        options.headers.set('Content-Type', 'application/json');
        return this.http.post(this._campaignUrl + "/create", JSON.stringify(campaign), options)
            .map(response => response.json())
            .map(response => response.newCampaignId)
            .catch(this.handleError);
    }

    updateCampaign(id:string, campaign:Campaign) {
        let options = new CustomBaseRequestOptions();
        options.headers.set('Content-Type', 'application/json');
        return this.http.put(this._campaignUrl + "/" + id + "/update", JSON.stringify(campaign), options)
            .catch(this.handleError);
    }

    getCampaign(id:string):Observable<Campaign> {
        let options = new CustomBaseRequestOptions();
        options.headers.set('Content-Type', 'application/json');
        return this.http.get(this._campaignUrl + "/" + id, options)
            .map(response => response.json())
            .map(campaign => new Campaign(campaign))
            .catch(this.handleError);
    }

    getCsvLink(id:string):string {
        return this._campaignUrl + "/" + id + "/csv";
    }

    getDownloadCsv(id: string) {
        let options = new CustomBaseRequestOptions();
        return this.http.get(this.getCsvLink(id), options)
            .map(resp => {
                let filename = resp.headers['x-suggested-filename'];
                if (! filename) {
                    filename = "campaigns_" + id + ".csv";
                }
                saveAs(new Blob([resp.text()], {type: "text/plain;charset=utf-8"}), filename);
                return filename;
            }).catch(this.handleError);
    }

    destroyCampaign(id:string) {
        let options = new CustomBaseRequestOptions();
        options.headers.set('Content-Type', 'application/json');
        return this.http.delete(this._campaignUrl + "/" + id + "/delete", options)
            .catch(this.handleError);
    }

    private extractData(res:Response) {
        if (res.status < 200 || res.status >= 300) {
            throw new Error('Bad response status: ' + res.status);
        }
        let body = res.json();
        return body.campaigns || {};
    }
}
